import gsap from "gsap";

let toggle = document.querySelector(".navbar-toggler") !== null ? document.querySelector(".navbar-toggler") : null;

if(toggle) {
    toggle.addEventListener("click", function (e) {
        toggleMenu();
    });
    
    function toggleMenu() {
        toggle.classList.toggle("is-active");
        document.querySelector("body").classList.toggle("menu-open");
        document.querySelector("body").classList.toggle("no-scroll");
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    let isSticky = false;
    const threshold = window.innerHeight / 3;

    function showHeader() {
        if (!isSticky) {
            header.classList.add('sticky');
            gsap.fromTo(header, 
                { y: -100, opacity: 0 }, 
                { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" }
            );
            isSticky = true;
        }
    }

    function hideHeader() {
        if (isSticky) {
            gsap.to(header, {
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    ease: "power2.in",
                    onComplete: () => {
                    header.classList.remove('sticky');
                }
            });
            isSticky = false;
        }
    }

    function handleScroll() {
        const scrollY = window.scrollY;
        if (scrollY > threshold) {
            showHeader();
        } else {
            hideHeader();
        }
    }

    window.addEventListener('scroll', handleScroll);
});
